import React from "react";
import "./view-crm-benefits.scss";
import { Box, Button } from "@mui/material";
import EqualWidthList from "../../../../../common/components/equal-width-list/EqualWidthList";
import { formatTitleCase, handleUnlimited } from "../../../../../utils/utils";

interface ViewCrmBenefitsProps {
  plans?: any;
  setIsEditBenefits?: any;
}

const ViewCrmBenefits: React.FC<ViewCrmBenefitsProps> = ({
  plans,
  setIsEditBenefits,
}) => {
  const formatSupportLevel = (value: any) => {
    if (value?.[0]?.checked && value?.[1]?.checked) {
      return "Email and Call Support";
    } else if (value?.[0]?.checked) {
      return "Email support";
    } else if (value?.[1]?.checked) {
      return "Call support";
    } else {
      return "-";
    }
  };
  return (
    <Box className="view-crm-benefits-wrapper ">
      <Box className="benefits-header">
        <p> Benefits</p>
        <Button
          variant="outlined"
          className="edit-button"
          onClick={() => setIsEditBenefits(true)}
        >
          Edit
        </Button>
      </Box>
      <Box className="benefits-body" gap={3}>
        <Box className="benefits-content-header">
          <EqualWidthList
            labelValue={handleUnlimited(plans?.noOfUsers)}
            label="No of Users"
          />
          <EqualWidthList
            labelValue={plans?.storageLimit?.value}
            label="Data Storage Limit"
          />
          <EqualWidthList
            labelValue={handleUnlimited(plans?.automationRulesLimit)}
            label="Custom Automation Rules"
          />
          <EqualWidthList
            labelValue={formatTitleCase(plans?.reportingLevel)}
            label="Reports"
          />
          <EqualWidthList
            labelValue={handleUnlimited(plans?.noOfLeads)}
            label="No of Leads "
          />
        </Box>
        <Box className="benefits-content-header">
          <EqualWidthList
            labelValue={handleUnlimited(plans?.noOfContacts)}
            label="No of Contacts"
          />
          <EqualWidthList
            labelValue={handleUnlimited(plans?.apiCallsPerMonth)}
            label="API Calls/month"
          />
          <EqualWidthList
            labelValue={formatSupportLevel(plans?.supportLevel)}
            label="Support "
          />
          <EqualWidthList labelValue={plans?.notes || "-"} label="Add Note" />
        </Box>
      </Box>
    </Box>
  );
};

export default ViewCrmBenefits;
